export default class Material {
  clone() {
    return new Material();
  }
}
